module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-04.0350d613.png";